import revive_payload_client_4sVQNw7RlN from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "C:/WORK/gits/jovsky/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import payload_client_yVLowv6hDl from "C:/WORK/gits/jovsky/node_modules/nuxt/dist/app/plugins/payload.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  payload_client_yVLowv6hDl
]